import type { UserProfile } from "../types/domain";

const listIds = ["hotelBookedWith", "restaurantBookedWith", "checklistCategories", "participantRoles", "transferModes"] as const;

// Missing fields are not an instruction to reset a user's known selections.
// Explicit arrays, including an empty array, remain authoritative.
export function preserveKnownPreferenceLists(previous: UserProfile | null, next: UserProfile | null): UserProfile | null {
  if (!previous || !next || previous.uid !== next.uid || !previous.preferences || !next.preferences) return next;
  const known = previous.preferences.sectionOptions;
  if (!known) return next;
  const incoming = next.preferences.sectionOptions;
  const sections = { ...incoming };
  let retained = false;
  for (const id of listIds) {
    if (!Array.isArray(incoming?.[id]) && Array.isArray(known[id])) {
      sections[id] = known[id];
      retained = true;
    }
  }
  return retained ? { ...next, preferences: { ...next.preferences, sectionOptions: sections } } : next;
}
